import {
    PERSON_RECEIVE,
    PERSON_ERROR,
    PERSON_CHANGE_MODE,
    ADDRESS_RECEIVE,
    ADDRESS_ERROR,
    ADDRESS_CHANGE_MODE,
    ORDER_RECEIVE,
    ORDER_ERROR,
    ORDER_CHANGE_MODE,
    ORDER_CHANGE_CURRENTPAGE,
    ORDER_SET_ORDER,
    ORDER_SET_LOADING,
    INVOICE_RECEIVE,
    INVOICE_ERROR,
    INVOICE_CHANGE_CURRENTPAGE,
    INVOICE_SET_LOADING,    
    FAVOURITE_LIST_RECEIVE,
    FAVOURITE_LIST_ERROR,
    FAVOURITE_LIST_CHANGE_MODE,
    FAVOURITE_LIST_SET_LIST,
    FAVOURITE_LIST_SET_BANNER,
    FAVOURITE_LIST_SET_LOADING,
    USER_DETAILS_RECEIVE,
    USER_DETAILS_ERROR
} from '../constants';
import { person as personReducer } from './Person.reducer';
import { address as addressReducer } from './Address.reducer';
import { order as orderReducer } from './Order.reducer';
import { invoice as invoiceReducer } from './Invoice.reducer';
import { favouritelist as favouritelistReducer } from './FavouriteLists.reducer';
import { user as userDetailsReducer } from './UserDetails.reducer';

const defaultState = {
    persons: {},
    addresses: {},
    orders: {
        currentPage: 1,
    },
};

export const myPage = (state = defaultState, action) => {
    const { type, payload } = action;
    switch (type) {
        case PERSON_RECEIVE:
        case PERSON_ERROR:
        case PERSON_CHANGE_MODE:
            return {
                ...state,
                persons: personReducer(state.persons, action),
            };
        case ADDRESS_RECEIVE:
        case ADDRESS_ERROR:
        case ADDRESS_CHANGE_MODE:
            return {
                ...state,
                addresses: addressReducer(state.addresses, action),
            };
        case ORDER_RECEIVE:
        case ORDER_ERROR:
        case ORDER_CHANGE_MODE:
        case ORDER_CHANGE_CURRENTPAGE:
        case ORDER_SET_ORDER:
        case ORDER_SET_LOADING:
            return {
                ...state,
                orders: orderReducer(state.orders, action),
            };
        case INVOICE_RECEIVE:
        case INVOICE_ERROR:
        case INVOICE_CHANGE_CURRENTPAGE:
        case INVOICE_SET_LOADING:
            return {
                ...state,
                invoices: invoiceReducer(state.invoices, action),
            };            
        case FAVOURITE_LIST_RECEIVE:
        case FAVOURITE_LIST_ERROR:
        case FAVOURITE_LIST_CHANGE_MODE:
        case FAVOURITE_LIST_SET_LIST:
        case FAVOURITE_LIST_SET_BANNER:
        case FAVOURITE_LIST_SET_LOADING:
            return {
                ...state,
                favouriteLists: favouritelistReducer(state.favouriteLists, action),
            };
        case USER_DETAILS_RECEIVE:
        case USER_DETAILS_ERROR:
            return {
                ...state,
                user: userDetailsReducer(state.user, action),
            };
        default:
            return state;
    }
};
